import { useEffect, useState } from "react";
import '../css/Home.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { useNavigate } from "react-router-dom";

import heroVideo from "../assets/hero.mp4";

import { storage } from "../firebase";
import { ref, getDownloadURL } from "firebase/storage";

import { FaArrowLeft, FaArrowRight, FaClock } from "react-icons/fa";

import { motion } from "framer-motion";
import PaintDivider from "./PaintDivider";

function Home() {

  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  //about
  const [about1Url, setAbout1Url] = useState("");
  const [about2Url, setAbout2Url] = useState("");

  useEffect(() => {
    getDownloadURL(ref(storage, "about1.jpeg")).then(setAbout1Url);
    getDownloadURL(ref(storage, "about2.jpeg")).then(setAbout2Url);
  }, []);

  //packages
  // States for images
  const [pkgImg1, setPkgImg1] = useState("");
  const [pkgImg2, setPkgImg2] = useState("");
  const [pkgImg3, setPkgImg3] = useState("");
  const [pkgImg4, setPkgImg4] = useState("");
  const [pkgImg5, setPkgImg5] = useState("");

  useEffect(() => {
    // Get all package images
    getDownloadURL(ref(storage, "pkg1.jpg")).then(setPkgImg1);
    getDownloadURL(ref(storage, "pkg2.jpg")).then(setPkgImg2);
    getDownloadURL(ref(storage, "pkg3.jpg")).then(setPkgImg3);
    getDownloadURL(ref(storage, "pkg4.jpg")).then(setPkgImg4);
    getDownloadURL(ref(storage, "pkg5.jpg")).then(setPkgImg5);
  }, []);

  //day Tours
  // States for images
  const [dayImg1, setDayImg1] = useState("");
  const [dayImg2, setDayImg2] = useState("");
  const [dayImg3, setDayImg3] = useState("");
  const [dayImg4, setDayImg4] = useState("");
  const [dayImg5, setDayImg5] = useState("");
  const [dayImg6, setDayImg6] = useState("");
  const [dayImg7, setDayImg7] = useState("");
  const [dayImg8, setDayImg8] = useState("");

  useEffect(() => {
    // Get all package images
    getDownloadURL(ref(storage, "day1.jpg")).then(setDayImg1);
    getDownloadURL(ref(storage, "day2.jpg")).then(setDayImg2);
    getDownloadURL(ref(storage, "day3.jpg")).then(setDayImg3);
    getDownloadURL(ref(storage, "day4.jpg")).then(setDayImg4);
    getDownloadURL(ref(storage, "day5.jpg")).then(setDayImg5);
    getDownloadURL(ref(storage, "day6.jpg")).then(setDayImg6);
    getDownloadURL(ref(storage, "day7.jpg")).then(setDayImg7);
    getDownloadURL(ref(storage, "day8.jpg")).then(setDayImg8);
  }, []);

  //destinations
  const [destiImg1, setDestiImg1] = useState("");
  const [destiImg2, setDestiImg2] = useState("");
  const [destiImg3, setDestiImg3] = useState("");
  const [destiImg4, setDestiImg4] = useState("");
  const [destiImg5, setDestiImg5] = useState("");
  const [destiImg6, setDestiImg6] = useState("");
  const [destiImg7, setDestiImg7] = useState("");
  const [destiImg8, setDestiImg8] = useState("");
  const [destiImg9, setDestiImg9] = useState("");
  const [destiImg10, setDestiImg10] = useState("");
  const [destiImg11, setDestiImg11] = useState("");

  useEffect(() => {
    getDownloadURL(ref(storage, "feature1.jpg")).then(setDestiImg1);
    getDownloadURL(ref(storage, "feature2.jpg")).then(setDestiImg2);
    getDownloadURL(ref(storage, "feature3.jpg")).then(setDestiImg3);
    getDownloadURL(ref(storage, "feature4.jpg")).then(setDestiImg4);
    getDownloadURL(ref(storage, "feature5.jpg")).then(setDestiImg5);
    getDownloadURL(ref(storage, "feature6.jpg")).then(setDestiImg6);
    getDownloadURL(ref(storage, "feature7.jpg")).then(setDestiImg7);
    getDownloadURL(ref(storage, "feature8.jpg")).then(setDestiImg8);
    getDownloadURL(ref(storage, "feature9.jpg")).then(setDestiImg9);
    getDownloadURL(ref(storage, "feature10.jpg")).then(setDestiImg10);
    getDownloadURL(ref(storage, "feature11.jpg")).then(setDestiImg11);
  }, []);

  //why choose us
  const [whyChooseUsImg, setWhyChooseUsImg] = useState("");

  useEffect(() => {
    getDownloadURL(ref(storage, "whychooseUs.jpeg")).then(setWhyChooseUsImg);
  }, []);

  //hospitality
  const [hospitalityImg, setHospitalityImg] = useState("");

  useEffect(() => {
    getDownloadURL(ref(storage, "hospitalityUs.jpeg")).then(setHospitalityImg);
  }, []);

  //vehicle
  const [sedan1, setVehicleImg1] = useState("");
  const [sedan2, setVehicleImg2] = useState("");
  const [sedan3, setVehicleImg3] = useState("");
  const [mini1, setVehicleImg4] = useState("");
  const [mini2, setVehicleImg5] = useState("");
  const [van1, setVehicleImg6] = useState("");
  const [bus1, setVehicleImg7] = useState("");
  const [bus2, setVehicleImg8] = useState("");

  useEffect(() => {
    getDownloadURL(ref(storage, "Toyota Prius.jpg")).then(setVehicleImg1);
    getDownloadURL(ref(storage, "Toyota Axio.JPG")).then(setVehicleImg2);
    getDownloadURL(ref(storage, "Toyota Hiace High Roof.jpg")).then(setVehicleImg3);
    getDownloadURL(ref(storage, "Suzuki's Wagon R.jpg")).then(setVehicleImg4);
    getDownloadURL(ref(storage, "Toyota Aqua.jpg")).then(setVehicleImg5);
    getDownloadURL(ref(storage, "Mini Van.jpg")).then(setVehicleImg6);
    getDownloadURL(ref(storage, "Mitsubishi Rosa.png")).then(setVehicleImg7);
    getDownloadURL(ref(storage, "King Long.jpg")).then(setVehicleImg8);
  }, []);

  //hotel
  const [hotelImg1, setHotelImg1] = useState("");
  const [hotelImg2, setHotelImg2] = useState("");
  const [hotelImg3, setHotelImg3] = useState("");
  const [hotelImg4, setHotelImg4] = useState("");
  const [hotelImg5, setHotelImg5] = useState("");
  const [hotelImg6, setHotelImg6] = useState("");

  useEffect(() => {
    getDownloadURL(ref(storage, "brand-logo1.png")).then(setHotelImg1);
    getDownloadURL(ref(storage, "brand-logo2.png")).then(setHotelImg2);
    getDownloadURL(ref(storage, "brand-logo3.png")).then(setHotelImg3);
    getDownloadURL(ref(storage, "brand-logo4.png")).then(setHotelImg4);
    getDownloadURL(ref(storage, "brand-logo5.png")).then(setHotelImg5);
    getDownloadURL(ref(storage, "brand-logo6.png")).then(setHotelImg6);
  }, []);

  //destinations
  useEffect(() => {
    const destSlider = document.getElementById("destSlider");
    const destPrevBtn = document.getElementById("destPrevBtn");
    const destNextBtn = document.getElementById("destNextBtn");

    const scrollAmount = destSlider.offsetWidth / 4 + 20; // roughly one card width

    // Manual scroll
    destNextBtn.addEventListener("click", () => {
      destSlider.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });
    destPrevBtn.addEventListener("click", () => {
      destSlider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });

    // Auto-scroll every 4 seconds
    const autoScroll = setInterval(() => {
      if (
        destSlider.scrollLeft + destSlider.clientWidth >=
        destSlider.scrollWidth - 5
      ) {
        destSlider.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        destSlider.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }, 4000);

    return () => clearInterval(autoScroll);
  }, []);

  //packages
  useEffect(() => {
    const slider = document.getElementById("pkgSlider");

    const scrollAmount = slider.offsetWidth / 4 + 20; // roughly one card width

    // Auto-scroll every 4 seconds
    const autoScroll = setInterval(() => {
      if (
        slider.scrollLeft + slider.clientWidth >=
        slider.scrollWidth - 5
      ) {
        slider.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }, 4000);

    return () => clearInterval(autoScroll);
  }, []);

  //day tour
  useEffect(() => {
    const daySlider = document.getElementById("daySlider");

    const dayScrollAmount = daySlider.offsetWidth / 4 + 20;

    const dayAutoScroll = setInterval(() => {
      if (daySlider.scrollLeft + daySlider.clientWidth >= daySlider.scrollWidth - 5) {
        daySlider.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        daySlider.scrollBy({ left: dayScrollAmount, behavior: "smooth" });
      }
    }, 4000);

    return () => clearInterval(dayAutoScroll);
  }, []);

  return (
    <div className="home-container">

      {/* Hero Section */}
      <section className="hero">
        <video
          className="hero-video"
          src={heroVideo}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="overlay"></div>
        <div className="slide-content" data-aos="fade-up">
          <p className="slide-title">Explore Sri Lanka</p>
          <h1 className="slide-text">
            Excitement Tours <br /> Adventure Awaits With Us!
          </h1>

          <button
            className="explore-btn"
            onClick={() => navigate("/packages")}
          >
            CHECK OUT OUR PACKAGES
          </button>
        </div>

        {/* 🎨 Paint Divider */}
        <PaintDivider color="#fff" />

      </section>

      {/* About Section */}
      <section className="about-section">
        {/* Left Text Area */}
        <div className="about-left" data-aos="fade-right">
          <h1>
            Let Us Plan Your Holiday In <br /> <span>Sri Lanka</span>
          </h1>

          <h2>MDP Travelers</h2>

          <p>
            Sri Lankan based locally owned company <strong>MDP Travelers</strong> specializes in handling
            wheelchair accessible holidays, senior citizen holidays, tailor-made family holidays, beach holidays,
            and wildlife tours in Sri Lanka. As one of the best travel agencies in Sri Lanka, we are fully geared
            to design and operate your holiday by putting together your interests and our expertise while maintaining
            the highest service standards.
          </p>

          <p>
            Whether it’s adventure, history, spiritualism or nature — we will provide you with an unmatched experience,
            customized tours, and personalized service at its best. We differentiate your Sri Lankan experience
            from the rest by touching the deepest sense and essence of every single aspect.
          </p>

          <div className="about-buttons">
            <button
              className="primary-btn"
              onClick={() => navigate("/about")}
            >
              Find Out More
            </button>
            <button
              className="outline-btn"
              onClick={() => navigate("/about-sri-lanka")}
            >
              More About Sri Lanka
            </button>
          </div>

          <p className="about-footer">
            <i className="fa fa-map-marker-alt"></i> Start your Sri Lankan adventure with MDP Travelers.
            Your unforgettable journey awaits!
          </p>
        </div>

        {/* Right Image Area */}
        <div className="about-right" data-aos="fade-left">
          <div className="image-container">
            <div className="image-left">
              {about1Url && <img src={about1Url} alt="Pool view" />}
            </div>
            <div className="image-right">
              {about2Url && <img src={about2Url} alt="Beach sunset" />}
            </div>

            <div className="ribbon">
              <span>1,500+ Customer Worldwide</span>
            </div>

            <motion.div
              className="experience-box"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, type: "spring" }}
              viewport={{ once: true }}
            >
              <h3>4</h3>
              <p>year of<br />experience</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section className="packages-section" data-aos="fade-up">
        <h2>
          Our <span className="highlight">Packages</span>
        </h2>

        <div className="packages-slider-wrapper">

          <div className="packages-slider" id="pkgSlider">

            {/* Package 1 */}
            <div
              className="package-card-home"
              onClick={() => navigate("/tour-package/CultureHeritage")}
              style={{ cursor: "pointer" }}
            >
              {pkgImg1 && <img src={pkgImg1} className="package-img" alt="Culture Heritage Trails" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 9 Days 8 Nights</p>
                <h4>Culture Heritage Trails</h4>
              </div>
            </div>

            {/* Package 2 */}
            <div
              className="package-card-home"
              onClick={() => navigate("/tour-package/HolidayTour")}
              style={{ cursor: "pointer" }}
            >
              {pkgImg2 && <img src={pkgImg2} className="package-img" alt="Accessible Holiday Tour" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 12 Days 11 Nights</p>
                <h4>Accessible Holiday Tour</h4>
              </div>
            </div>

            {/* Package 3 */}
            <div
              className="package-card-home"
              onClick={() => navigate("/tour-package/HoneymoonTrail")}
              style={{ cursor: "pointer" }}
            >
              {pkgImg3 && <img src={pkgImg3} className="package-img" alt="Honeymoon Trail" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 14 Days 13 Nights</p>
                <h4>Honeymoon Trail</h4>
              </div>
            </div>

            {/* Package 4 */}
            <div
              className="package-card-home"
              onClick={() => navigate("/tour-package/RamayanaTour")}
              style={{ cursor: "pointer" }}
            >
              {pkgImg4 && <img src={pkgImg4} className="package-img" alt="Ramayana Tour" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 9 Days 8 Nights</p>
                <h4>Ramayana Tour</h4>
              </div>
            </div>

            {/* Package 5 */}
            <div
              className="package-card-home"
              onClick={() => navigate("/tour-package/EcoTrail")}
              style={{ cursor: "pointer" }}
            >
              {pkgImg5 && <img src={pkgImg5} className="package-img" alt="Eco Trail" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 9 Days 8 Nights</p>
                <h4>Eco Trail</h4>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Day Tours Section */}
      <section className="packages-section" data-aos="fade-up">
        <h2>
          Day <span className="highlight">Tours</span>
        </h2>

        <div className="packages-slider-wrapper">

          {/* SLIDER */}
          <div className="packages-slider" id="daySlider">

            {/* Day Tour 1 */}
            <div
              className="package-card-home"
              onClick={() => navigate("/day-tours/ColomboCityTour")}
              style={{ cursor: "pointer" }}
            >
              {dayImg1 && <img src={dayImg1} className="package-img" alt="Colombo City Day Tour" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 1 Day</p>
                <h4>Colombo City Tour</h4>
              </div>
            </div>

            {/* Day Tour 2 */}
            <div
              className="package-card-home"
              onClick={() => navigate("/day-tours/ColomboBenthotaGalle")}
              style={{ cursor: "pointer" }}
            >
              {dayImg2 && <img src={dayImg2} className="package-img" alt="Galle & Unawatuna Day Tour" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 1 Day</p>
                <h4>Colombo Galle Tour</h4>
              </div>
            </div>

            {/* Day Tour 3 */}
            <div
              className="package-card-home"
              onClick={() => navigate("/day-tours/ColomboKandy")}
              style={{ cursor: "pointer" }}
            >
              {dayImg3 && <img src={dayImg3} className="package-img" alt="Kandy Cultural Day Tour" />}
              <div class="package-info">
                <p className="package-days"><FaClock /> 1 Day</p>
                <h4>Colombo Kandy Tour</h4>
              </div>
            </div>

            {/* Day Tour 4 */}
            <div
              className="package-card-home"
              onClick={() => navigate("/day-tours/ColomboSigiriyaDambulla")}
              style={{ cursor: "pointer" }}
            >
              {dayImg4 && <img src={dayImg4} className="package-img" alt="Sigiriya & Dambulla Day Tour" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 1 Day</p>
                <h4>Colombo Sigiriya Tour</h4>
              </div>
            </div>

            {/* Day Tour 5 */}
            <div
              className="package-card-home"
              onClick={() => navigate("/day-tours/ColomboKithulgala")}
              style={{ cursor: "pointer" }}
            >
              {dayImg5 && <img src={dayImg5} className="package-img" alt="Kithulgala Day Tour" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 1 Day</p>
                <h4>Colombo Kithulgala Tour</h4>
              </div>
            </div>

            {/* Day Tour 6 */}
            {/* <div
              className="package-card-home"
              onClick={() => navigate("/day-tours/ColomboUdawalawe")}
              style={{ cursor: "pointer" }}
            >
              {dayImg6 && <img src={dayImg6} className="package-img" alt="Udawalawe Day Tour" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 1 Day</p>
                <h4>Colombo Udawalawe Tour</h4>
              </div>
            </div> */}

            {/* Day Tour 7 */}
            {/* <div
              className="package-card-home"
              onClick={() => navigate("/day-tours/ColomboTrincomalee")}
              style={{ cursor: "pointer" }}
            >
              {dayImg7 && <img src={dayImg7} className="package-img" alt="Colombo Trincomalee" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 1 Day</p>
                <h4>Colombo Trincomalee Tour</h4>
              </div>
            </div> */}

            {/* Day Tour 7 */}
            {/* <div
              className="package-card-home"
              onClick={() => navigate("/day-tours/ColomboArugamBay")}
              style={{ cursor: "pointer" }}
            >
              {dayImg8 && <img src={dayImg8} className="package-img" alt="Colombo Arugam Bay" />}
              <div className="package-info">
                <p className="package-days"><FaClock /> 1 Day</p>
                <h4>Colombo Arugam Bay Tour</h4>
              </div>
            </div> */}

          </div>
        </div>
      </section>

      {/* Best Destinations Section */}
      <section className="best-destinations-section" data-aos="fade-up">
        <h2>
          Amazing Tour Places <br /> Around The <span className="highlight">Sri Lanka</span>
        </h2>

        <div className="destinations-slider-wrapper">
          <button className="arrow-btn left-des" id="destPrevBtn">
            <FaArrowLeft />
          </button>

          <div className="destinations-slider" id="destSlider">
            <div
              className="destination-card-home"
              onClick={() => navigate("/destinations/Mirissa")}
              style={{ cursor: "pointer" }}
            >
              {destiImg1 && <img src={destiImg1} alt="Yala" />}
              <div className="destination-info">
                <p className="location">📍 South Coast, Sri Lanka</p>
                <h4>Mirissa</h4>
                <p>Southern beach gem.</p>
                <p>
                  Coconut Tree Hill, Whale Watching, Parrot Rock, Surfing, Snorkeling, Driving, Beach Relaxation.
                </p>
              </div>
            </div>

            <div
              className="destination-card-home"
              onClick={() => navigate("/destinations/Sigiriya")}
              style={{ cursor: "pointer" }}
            >
              {destiImg2 && <img src={destiImg2} alt="Kandy" />}
              <div className="destination-info">
                <p className="location">📍 Central, Sri Lanka</p>
                <h4>Sigiriya</h4>
                <p>
                  City blends history, culture, beauty, adventure and sigiriya fortress the 8'th world wonder, showcasing nature's and mankind's marvels.
                </p>
              </div>
            </div>

            <div
              className="destination-card-home"
              onClick={() => navigate("/destinations/Anuradhapura")}
              style={{ cursor: "pointer" }}
            >
              {destiImg3 && <img src={destiImg3} alt="Yala" />}
              <div className="destination-info">
                <p className="location">📍 North Central, Sri Lanka</p>
                <h4>Anuradhapura</h4>
                <p>
                  Anuradhapura Sri Lanka’s first capital showcases ancient history, buddhist heritage and engineering marvels as a UNESCO world heritage site.
                </p>
              </div>
            </div>

            <div
              className="destination-card-home"
              onClick={() => navigate("/destinations/Polonnaruwa")}
              style={{ cursor: "pointer" }}
            >
              {destiImg4 && <img src={destiImg4} alt="Yala" />}
              <div className="destination-info">
                <p className="location">📍 North Central, Sri Lanka</p>
                <h4>Polonnaruwa</h4>
                <p>
                  UNESCO World Heritage site rich in historical exploration, cultural significance and ancient architectural marvels showcasing timeless beauty.
                </p>
              </div>
            </div>

            <div
              className="destination-card-home"
              onClick={() => navigate("/destinations/Ella")}
              style={{ cursor: "pointer" }}
            >
              {destiImg5 && <img src={destiImg5} alt="Yala" />}
              <div className="destination-info">
                <p className="location">📍 Uva, Sri Lanka</p>
                <h4>Ella</h4>
                <p>
                  Nature lovers and adventurers can relax amidst stunning views. major attractions include Adam's Peak, Nine Arches and Ravana Falls
                </p>
              </div>
            </div>

            <div
              className="destination-card-home"
              onClick={() => navigate("/destinations/Yala")}
              style={{ cursor: "pointer" }}
            >
              {destiImg6 && <img src={destiImg6} alt="Yala" />}
              <div className="destination-info">
                <p className="location">📍 Uva, Sri Lanka</p>
                <h4>Yala</h4>
                <p>
                  Yala National Park is one of the most famous wildlife reserves in Sri Lanka. It is located in the southeastern part of the country and covers a large area of forests, grasslands, lagoons, and beaches.
                </p>
              </div>
            </div>

            <div
              className="destination-card-home"
              onClick={() => navigate("/destinations/Kandy")}
              style={{ cursor: "pointer" }}
            >
              {destiImg7 && <img src={destiImg7} alt="Yala" />}
              <div className="destination-info">
                <p className="location">📍 Central, Sri Lanka</p>
                <h4>Kandy</h4>
                <p>
                  Kandy is a city located withing the culture triangle vibrant city renowed for its culture heritage, scieni beauty & Its religious significant.
                </p>
              </div>
            </div>

            <div
              className="destination-card-home"
              onClick={() => navigate("/destinations/Nuwara-Eliya")}
              style={{ cursor: "pointer" }}
            >
              {destiImg8 && <img src={destiImg8} alt="Yala" />}
              <div className="destination-info">
                <p className="location">📍 Central, Sri Lanka</p>
                <h4>Nuwara Eliya</h4>
                <p>
                  Nuwara Eliya called little England, is a charming hill station famous for its colonial architecture, cool climate, tea plantations and greenery.
                </p>
              </div>
            </div>

            <div
              className="destination-card-home"
              onClick={() => navigate("/destinations/Eco-Escapes")}
              style={{ cursor: "pointer" }}
            >
              {destiImg9 && <img src={destiImg9} alt="Yala" />}
              <div className="destination-info">
                <p className="location">📍 Eco Escapes, Sri Lanka</p>
                <h4>Eco Escapes</h4>
                <p>
                  UNESCO World Heritage site rich in historical exploration, cultural significance, and ancient architectural marvels showcasing timeless beauty.
                </p>
              </div>
            </div>

            <div
              className="destination-card-home"
              onClick={() => navigate("/destinations/Herbal-Garden")}
              style={{ cursor: "pointer" }}
            >
              {destiImg10 && <img src={destiImg10} alt="Herbal Garden Sri Lanka" />}
              <div className="destination-info">
                <p className="location">📍 Herbal Garden, Sri Lanka</p>
                <h4>Herbal Garden</h4>
                <p>
                  A serene Ayurvedic sanctuary filled with healing herbs, medicinal plants, and traditional wellness practices, offering an immersive journey into Sri Lanka’s natural health culture.
                </p>
              </div>
            </div>

            <div
              className="destination-card-home"
              onClick={() => navigate("/destinations/Gems")}
              style={{ cursor: "pointer" }}
            >
              {destiImg11 && <img src={destiImg11} alt="Gems of Sri Lanka" />}
              <div className="destination-info">
                <p className="location">📍 Gems of Sri Lanka</p>
                <h4>Gems of Sri Lanka</h4>
                <p>
                  Discover Sri Lanka’s legendary gemstone heritage, where vibrant blue sapphires, rare gems, and centuries-old mining traditions come together to create a sparkling journey into the island’s natural treasures.
                </p>
              </div>
            </div>

          </div>

          <button className="arrow-btn right-des" id="destNextBtn">
            <FaArrowRight />
          </button>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section-home" data-aos="fade-up">
        <div className="why-choose-container">
          <div className="why-choose-image">
            {whyChooseUsImg && <img src={whyChooseUsImg} />}
            <div className="explore-badge">
              <span>Never stop<br />Exploring</span>
            </div>
          </div>

          <div className="why-choose-content">
            <h2>Why <span className="highlight">Choose Us</span></h2>
            <p>
              A number of people have chosen us as their number one travel destination
              management company and you will also choose us for the following reasons…
            </p>
            <p>
              We are one of the leading tour operators in Sri Lanka who provide tours to
              exotic destinations.
            </p>
            <p>
              Your safety is our priority &amp; we ensure safe travels across Sri Lanka’s
              scenic beauty.
            </p>
            <p>
              We offer affordable prices for all your tour packages which you can compare
              with any travel agent in Sri Lanka.
            </p>
            <p>
              Trusted local guides who will show you the hidden gems of Sri Lanka.
            </p>
            <p>
              We have a passionate and professional team consisting of 40 representatives
              who possess extensive knowledge of the Sri Lankan tourism industry.
            </p>

            <div className="why-choose-buttons">
              <button className="primary-btn" onClick={() => navigate("/about")}>ABOUT Us</button>
              <button className="outline-btn" onClick={() => navigate("/whyChooseUs")}>WHY Choose Us</button>
            </div>
          </div>
        </div>
      </section>

      {/* Our Hospitality Highlights Section */}
      <section className="hospitality-section" data-aos="fade-up">

        <div className="hospitality-container">

          {/* Left Image Side */}
          <div className="hospitality-image" data-aos="fade-right">
            {hospitalityImg && <img src={hospitalityImg} />}
            {/* <div className="hospitality-badge">
              <span>Exclusive offer and comprehensive<br />travel package details provided.</span>
            </div> */}
          </div>

          {/* Right Content Side */}
          <div className="hospitality-content" data-aos="fade-left">

            <div className="hospitality-cards">
              {/* Card 1 */}
              <div className="hospitality-card">
                <h3>COMPLIMENTARY OFFER FROM OUR COMPANY</h3>
                <ul>
                  <li>Complimentary company T-shirt</li>
                  <li>2 Mineral Water bottles (2 liters/day per client)</li>
                  <li>Local SIM Cards (1 per six persons)</li>
                  <li>Entry permit for Traditional Cultural performance (Kandy)</li>
                  <li>Day tour not applicable</li>
                </ul>
              </div>

              {/* Card 2 */}
              <div className="hospitality-card">
                <h3>OUR PACKAGE INCLUDES</h3>
                <ul>
                  <li>Accommodation in Double Sharing A/C Rooms</li>
                  <li>Meal Basis on H/B (Breakfast/Dinner – Veg or Non-Veg)</li>
                  <li>Transportation by New Luxury A/C Vehicles</li>
                  <li>Guiding by English-speaking Tourist Lecturer</li>
                  <li>All Government Taxes included</li>
                </ul>
              </div>

              {/* Card 3 */}
              <div className="hospitality-card">
                <h3>OUR PACKAGE EXCLUDES</h3>
                <ul>
                  <li>Airfare and Visa Charges</li>
                  <li>Additional Services not specified</li>
                  <li>Entrance Fees (optional)</li>
                  <li>Lunch during the tour</li>
                  <li>Day tours – refer to separate packages</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Testimonials Section */}
      <section className="reviews-section" data-aos="fade-up">

        {/* Tripadvisor Rating */}
        <div className="rating-header">
          <h3>EXCELLENT</h3>
          <div className="rating-circles">
            <span></span><span></span><span></span><span></span><span></span>
          </div>
          <p>Based on <strong>126 reviews</strong></p>
          <img src="https://static.tacdn.com/img2/brand_refresh/Tripadvisor_lockup_horizontal_secondary_registered.svg" alt="Tripadvisor" />
        </div>

        {/* Tripadvisor Reviews */}
        <div className="review-slider">
          <button className="nav-btn">‹</button>

          <div className="review-cards">
            <div className="review-card">
              <h4>Tbrks</h4>
              <div className="stars green">★★★★★</div>
              <p>
                Good experience. They were flexible with timing to what suited us.
                The vehicle was clean and comfortable.
              </p>
              <span className="read-more">Read more</span>
            </div>

            <div className="review-card">
              <h4>Eluned M</h4>
              <div className="stars green">★★★★★</div>
              <p>
                Very good company, punctual and considerate.
                Great service, very reasonable price.
              </p>
              <span className="read-more">Read more</span>
            </div>

            <div className="review-card">
              <h4>Pradeep S</h4>
              <div className="stars green">★★★★★</div>
              <p>
                Good communication. Fast service.
                Friendly and professional service.
              </p>
              <span className="read-more">Read more</span>
            </div>
          </div>

          <button className="nav-btn">›</button>
        </div>

        {/* Google Rating */}
        <div className="rating-header google">
          <h3>EXCELLENT</h3>
          <div className="stars gold">★★★★★</div>
          <p>Based on <strong>143 reviews</strong></p>
          <img src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" alt="Google" />
        </div>

        {/* Google Reviews */}
        <div className="review-slider">
          <button className="nav-btn">‹</button>

          <div className="review-cards">
            <div className="review-card">
              <h4>Loomie</h4>
              <div className="stars gold">★★★★★</div>
              <p>Ging alles reibungslos, pünktlich Abholung.</p>
            </div>

            <div className="review-card">
              <h4>Breda Timbs</h4>
              <div className="stars gold">★★★★★</div>
              <p>
                Great experience, spotless clean car,
                driver very helpful.
              </p>
            </div>

            <div className="review-card">
              <h4>Roy Smith</h4>
              <div className="stars gold">★★★★★</div>
              <p>Safe and efficient driver and reasonable price!</p>
            </div>
          </div>

          <button className="nav-btn">›</button>
        </div>

      </section>

      {/* Vehicles Section */}
      <section className="vehicle-collection" data-aos="fade-up">
        <h2 className="vehicle-title">Our Luxury Vehicles</h2>

        {/* Sedan Category */}
        <h3 className="vehicle-category">Sedan – Comfortable 3 Pax</h3>
        <div className="vehicle-grid">
          <div className="vehicle-card">
            <div className="vehicle-img-wrapper color-1">
              {sedan1 && <img src={sedan1} />}
            </div>
            <h4 className="vehicle-name">Toyota Prius</h4>
            <p className="vehicle-seats">(3 Seats)</p>
          </div>

          <div className="vehicle-card">
            <div className="vehicle-img-wrapper color-2">
              {sedan2 && <img src={sedan2} />}
            </div>
            <h4 className="vehicle-name">Toyota Axio</h4>
            <p className="vehicle-seats">(3 Seats)</p>
          </div>
        </div>

        {/* Mini Cars Category */}
        <h3 className="vehicle-category">Mini Cars – 2 Pax</h3>
        <div className="vehicle-grid">
          <div className="vehicle-card">
            <div className="vehicle-img-wrapper color-4">
              {mini1 && <img src={mini1} />}
            </div>
            <h4 className="vehicle-name">Suzuki Wagon R</h4>
            <p className="vehicle-seats">(2 Seats)</p>
          </div>

          <div className="vehicle-card">
            <div className="vehicle-img-wrapper color-5">
              {mini2 && <img src={mini2} />}
            </div>
            <h4 className="vehicle-name">Toyota Aqua</h4>
            <p className="vehicle-seats">(2 Seats)</p>
          </div>
        </div>

        {/* Vans Category */}
        <h3 className="vehicle-category">Vans – 4 Pax</h3>
        <div className="vehicle-grid">
          <div className="vehicle-card">
            <div className="vehicle-img-wrapper color-1">
              {sedan3 && <img src={sedan3} />}
            </div>
            <h4 className="vehicle-name">Toyota Hiace High Roof</h4>
            <p className="vehicle-seats">(12 Seats)</p>
          </div>

          <div className="vehicle-card">
            <div className="vehicle-img-wrapper color-2">
              {van1 && <img src={van1} />}
            </div>
            <h4 className="vehicle-name">Mini Van</h4>
            <p className="vehicle-seats">(4 Seats)</p>
          </div>
        </div>

        {/* Buses Category */}
        <h3 className="vehicle-category">Buses – 12 Pax</h3>
        <div className="vehicle-grid">
          <div className="vehicle-card">
            <div className="vehicle-img-wrapper color-4">
              {bus1 && <img src={bus1} />}
            </div>
            <h4 className="vehicle-name">Mitsubishi Rosa</h4>
            <p className="vehicle-seats">(36 Seats)</p>
          </div>

          <div className="vehicle-card">
            <div className="vehicle-img-wrapper color-5">
              {bus2 && <img src={bus2} />}
            </div>
            <h4 className="vehicle-name">King Long</h4>
            <p className="vehicle-seats">(54 Seats)</p>
          </div>
        </div>

        <p className="home-p">
          Explore our premium vehicles trusted by 1000+ customers worldwide.
        </p>
      </section>

      {/* Hotel Brands Section */}
      <section className="hotel-brands-section" data-aos="fade-up">
        <h2 className="hotel-brands-title">
          We’ve been mentioned in Below Brands
        </h2>

        <div className="hotel-brands-logos">

          {hotelImg1 && <img src={hotelImg1} className="hotel-logo" />}

          {hotelImg2 && <img src={hotelImg2} className="hotel-logo" />}

          {hotelImg3 && <img src={hotelImg3} className="hotel-logo" />}

          {hotelImg4 && <img src={hotelImg4} className="hotel-logo" />}

          {hotelImg5 && <img src={hotelImg5} className="hotel-logo" />}

          {hotelImg6 && <img src={hotelImg6} className="hotel-logo" />}

        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-box">
          <div className="cta-left">
            <img src={require("../assets/hile.png")} className="cta-icon" alt="icon" />
            <div className="cta-text">
              <h2>Ready To Adventure And Enjoy Natural</h2>
              <p>Reach MDP Travelers For A Secure, Luxurious, And Unforgettable Adventure!</p>
            </div>
          </div>

          <img src={require("../assets/plan.png")} className="cta-plane" alt="plane" />

          <button className="cta-btn">LET’S GET STARTED</button>
        </div>
      </section>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/94779702662"
        className="whatsapp-fab"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
          alt="WhatsApp"
          className="whatsapp-icon"
        />
      </a>

    </div>
  );
}

export default Home;
